export const SIZES = {
    xs: 24,
    s: 48,
    m: 64,
    l: 80,
    xl: 128,
    xxl: 144,
    16: 16,
    24: 24,
    48: 48,
    64: 64,
    80: 80,
    96: 96,
    128: 128,
    144: 144,
};

export const STROKE = {
    xs: 4,
    s: 4,
    m: 6,
    l: 8,
    xl: 10,
    xxl: 12,
    16: 2,
    24: 4,
    48: 4,
    64: 6,
    80: 8,
    96: 8,
    128: 10,
    144: 12,
};

export const VIEW_TITLE = {
    xs: 'small',
    s: 'small',
    m: 'small',
    l: 'xsmall',
    xl: 'medium',
    xxl: 'medium',
    16: 'small',
    24: 'small',
    48: 'small',
    64: 'small',
    80: 'xsmall',
    96: 'xsmall',
    128: 'medium',
    144: 'medium',
} as const;

export const VIEW_TEXT = {
    xs: 'secondary-small',
    s: 'secondary-small',
    m: 'secondary-large',
    l: 'secondary-large',
    xl: 'secondary-large',
    xxl: 'secondary-large',
    16: 'secondary-small',
    24: 'secondary-small',
    48: 'secondary-small',
    64: 'secondary-large',
    80: 'secondary-large',
    96: 'secondary-large',
    128: 'secondary-large',
    144: 'secondary-large',
} as const;

export const TYPOGRAPHY_COLOR = ['primary', 'secondary', 'tertiary', 'positive', 'negative'];

export const SIZE_TO_CLASSNAME_MAP = {
    xs: 'size-24',
    s: 'size-48',
    m: 'size-64',
    l: 'size-80',
    xl: 'size-128',
    xxl: 'size-144',
    16: 'size-16',
    24: 'size-24',
    48: 'size-48',
    64: 'size-64',
    80: 'size-80',
    96: 'size-96',
    128: 'size-128',
    144: 'size-144',
};

export const MAX_PROGRESS_VALUE = 100;

export const MIN_TIMER_VALUE = 0;
export const MAX_TIMER_VALUE = 3599;
